import { ReactionType } from '../../../../generated/graphql';

export function getEmojiForReaction(type: ReactionType): string {
  const reactionTypeEmojiMap: Record<ReactionType, string> = {
    Clap: '👏',
    Comment: 'Comment',
    Cry: '😭',
    Disappointed: '😔',
    FaceHearts: '🥰',
    Fire: '🔥',
    Goat: '🐐',
    Heart: '❤️',
    Horns: '🤟',
    Joy: '😂',
    Muscle: '💪',
    OpenMouth: '😮',
    RaisedHands: '🙌',
    Rocket: '🚀',
    Tada: '🎉',
    ThumbsUp: '👍',
  };

  return reactionTypeEmojiMap[type] ?? null;
}
